export default "__VITE_ASSET__d098e5f6__"